import { RatingTogether } from 'react-together-primereact'

export function PrimeReactRatingTogetherDemo() {
  return (
    <div className='flex-col place-items-center'>
      <RatingTogether rtKey='rating-doc-demo' />
    </div>
  )
}
